import { render, staticRenderFns } from "./ClassApprovals.vue?vue&type=template&id=f9fd01f0&"
import script from "./ClassApprovals.vue?vue&type=script&lang=js&"
export * from "./ClassApprovals.vue?vue&type=script&lang=js&"
import style0 from "./ClassApprovals.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports